<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-green" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            { staticClass: "p-0" },
            [
              _c(
                "b-col",
                { staticClass: "green border-right pt-0-custom p-2 pr-3" },
                [
                  _c("div", [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        [
                          _c("b-avatar", {
                            staticClass: "badge-minimal",
                            attrs: {
                              size: "40",
                              variant: "light-primary mr-1",
                              badge: "",
                              text: _vm.firstLetter,
                              "badge-variant": "success",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "spotpumkin" },
                          [
                            _vm._v(" " + _vm._s(_vm.userName) + " "),
                            _c("GoldUser", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.value.userLevel === "GOLD",
                                  expression: "value.userLevel === 'GOLD'",
                                },
                              ],
                              staticClass: "user-level",
                            }),
                            _c("Silver", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.value.userLevel === "REGULAR",
                                  expression: "value.userLevel === 'REGULAR'",
                                },
                              ],
                              staticClass: "user-level",
                            }),
                            _c("Platinum", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.value.userLevel === "PLATINUM",
                                  expression: "value.userLevel === 'PLATINUM'",
                                },
                              ],
                              staticClass: "user-level",
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "light-primary" }, [
                          _vm._v(_vm._s(_vm.$t("greenPopup.Online"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between mt-2" },
                      [
                        _c("div", { staticClass: "order-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("greenPopup.Completed-orders")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "order-text" }, [
                          _vm._v(_vm._s(_vm.completedOrders)),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between mt-1-5" },
                      [
                        _c("div", { staticClass: "order-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("greenPopup.Completion-rate")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "order-text" }, [
                          _vm._v(_vm._s(_vm.completionRate) + "%"),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between mt-1-5" },
                      [
                        _c("div", { staticClass: "order-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("greenPopup.Payment-window")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "order-text" }, [
                          _vm._v(_vm._s(_vm.paymentWindow)),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between mt-1-5" },
                      [
                        _c("div", { staticClass: "order-text" }, [
                          _vm._v(_vm._s(_vm.$t("greenPopup.Release-Time"))),
                        ]),
                        _c("div", { staticClass: "order-text" }, [
                          _vm._v(_vm._s(_vm.releaseTime)),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.terms,
                            expression: "terms",
                          },
                        ],
                      },
                      [
                        _c("div", { staticClass: "horizontal mt-3" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("greenPopup.Trading-terms")) +
                              " "
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "trading-text mt-1 terms-scroll" },
                          [_vm._v(" " + _vm._s(_vm.terms) + " ")]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _c(
                "b-col",
                { staticClass: "white pt-0-custom p-2 pl-3 center-form" },
                [
                  _c("validation-observer", {
                    ref: "createSell",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.validationForm($event)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "p-2-for-desk w-100 center-form",
                                    attrs: { lg: "12" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mb-0-5",
                                        staticStyle: {
                                          color: "black",
                                          "font-size": "14px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("feedbback.Unit-price")
                                            ) +
                                            ": "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.unitPrice + " " + _vm.currency
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "w-rt",
                                        attrs: { lg: "12" },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "feedbback.YouReceive"
                                            ),
                                            rules: {
                                              required: true,
                                              maxQuantity: _vm.availableBalance,
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-prepend",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "input-group-text you-buy-w",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "feedbback.YouSell"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("b-form-input", {
                                                          staticClass:
                                                            "form-control you-buy-in",
                                                          staticStyle: {
                                                            "text-align":
                                                              "right",
                                                            "padding-right":
                                                              "17px",
                                                          },
                                                          attrs: {
                                                            placeholder: "0.00",
                                                            name: _vm.$t(
                                                              "feedbback.YouReceive"
                                                            ),
                                                          },
                                                          on: {
                                                            keypress:
                                                              _vm.validateKeyPress,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.displayQuantity,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.displayQuantity =
                                                                $$v
                                                            },
                                                            expression:
                                                              "displayQuantity",
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-append",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "input-group-text you-buy-input",
                                                              },
                                                              [
                                                                _vm.coinUrl
                                                                  ? _c("b-img", {
                                                                      staticClass:
                                                                        "align-middle mr-25 currency-image-height",
                                                                      attrs: {
                                                                        src: _vm.coinUrl,
                                                                        size: "16",
                                                                      },
                                                                    })
                                                                  : _vm._e(),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.coin
                                                                      )
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c("Errors", {
                                                      attrs: {
                                                        error: errors[0],
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "mb-1 margin-top-10" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("feedbback.Available")
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.availableBalance +
                                                " " +
                                                _vm.coin
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "w-rt",
                                        attrs: { lg: "12" },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("feedbback.YouSell"),
                                            rules: {
                                              required: true,
                                              maxAmount:
                                                _vm.value.maxOrderPriceLimit,
                                              minAmount:
                                                _vm.value.minOrderPriceLimit,
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-prepend",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "input-group-text you-buy-w",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "feedbback.YouReceive"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("b-form-input", {
                                                          staticClass:
                                                            "form-control you-buy-in",
                                                          staticStyle: {
                                                            "text-align":
                                                              "right",
                                                            "padding-right":
                                                              "17px",
                                                          },
                                                          attrs: {
                                                            placeholder: "0.00",
                                                            name: _vm.$t(
                                                              "feedbback.YouSell"
                                                            ),
                                                          },
                                                          on: {
                                                            keypress:
                                                              _vm.validateKeyPress,
                                                          },
                                                          model: {
                                                            value: _vm.amount,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.amount = $$v
                                                            },
                                                            expression:
                                                              "amount",
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-append",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "input-group-text you-buy-input",
                                                              },
                                                              [
                                                                _vm.currencyUrl
                                                                  ? _c("b-img", {
                                                                      staticClass:
                                                                        "align-middle mr-25 currency-image-height",
                                                                      attrs: {
                                                                        src: _vm.currencyUrl,
                                                                        size: "16",
                                                                      },
                                                                    })
                                                                  : _vm._e(),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.currency
                                                                      )
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c("Errors", {
                                                      attrs: {
                                                        error: errors[0],
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "margin-top-10" },
                                      [
                                        _c("div", { staticClass: "mb-1" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("feedbback.Order-limit")
                                              ) +
                                              ": " +
                                              _vm._s(
                                                _vm.value.minOrderPriceLimit +
                                                  " - " +
                                                  _vm.value.maxOrderPriceLimit +
                                                  " " +
                                                  _vm.currency
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.fee,
                                                expression: "fee",
                                              },
                                            ],
                                            staticClass: "mb-1",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("feedbback.Fee")
                                                ) +
                                                ": " +
                                                _vm._s(
                                                  _vm.fee + " " + _vm.coin
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "b-form-group",
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-lable mb-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ads.Payment-Method"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "red-star" },
                                                  [_vm._v("*")]
                                                ),
                                              ]
                                            ),
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "ads.Payment-Method"
                                                ),
                                                rules: {
                                                  required: true,
                                                },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "custom-add-pay",
                                                          },
                                                          [
                                                            _c(
                                                              "PaymentMethodSelect",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.paymentMethodsOptions,
                                                                  showAddPaymentMethod:
                                                                    _vm.showAddPaymentMethod,
                                                                  clearable: false,
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.paymentMethods,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.paymentMethods =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "paymentMethods",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "b-button",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "b-tooltip",
                                                                    rawName:
                                                                      "v-b-tooltip.hover.v-primary",
                                                                    modifiers: {
                                                                      hover: true,
                                                                      "v-primary": true,
                                                                    },
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "btn-icon rounded-circle",
                                                                attrs: {
                                                                  title: _vm.$t(
                                                                    "ads.addNewPaymentMethod"
                                                                  ),
                                                                  variant:
                                                                    "primary",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.openAddPayment(
                                                                        true
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "feather-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: "PlusIcon",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c("Errors", {
                                                          attrs: {
                                                            error: errors[0],
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "w-rt",
                                        attrs: { md: "12" },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "USDT-btn-grey mt-1",
                                            attrs: {
                                              type: "submit",
                                              variant: "primary",
                                              block: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("feedbback.Sell", {
                                                    coin: _vm.coin,
                                                  })
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("KycNotComplete", {
        attrs: {
          showPop: _vm.showPop,
          onModalHidden: _vm.onModalHidden,
          msg: _vm.warningMsg,
        },
      }),
      _c("AddPaymentMethod", {
        attrs: {
          AddPayment: _vm.AddPayment,
          closePaymentPop: _vm.closePaymentPop,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/buy-sell/PopupSell.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import * as vuex from 'vuex';
import libs_api_api from '@/libs/api/api';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import layouts_components_PaymentMethodSelect_vue from '@/layouts/components/PaymentMethodSelect.vue';
import * as veevalidate from 'vee-validate';
import layouts_components_KycNotComplete_vue from '@/layouts/components/KycNotComplete.vue';
import assets_rashi_coin_gold_user_svg from '@/assets/rashi-coin/gold-user.svg';
import assets_rashi_coin_silver_svg from '@/assets/rashi-coin/silver.svg';
import assets_rashi_coin_platinum_svg from '@/assets/rashi-coin/platinum.svg';
import validations from '@validations';
import layouts_components_AddPaymentMethod_vue from '@/layouts/components/AddPaymentMethod.vue';
import utils_constants from '@/utils/constants';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















export default ({
  render,
  staticRenderFns,
  components: {
    Silver: assets_rashi_coin_silver_svg,
    Platinum: assets_rashi_coin_platinum_svg,
    BCol: bootstrapvue["BCol"],
    BRow: bootstrapvue["BRow"],
    BAvatar: bootstrapvue["BAvatar"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BFormInput: bootstrapvue["BFormInput"],
    BInputGroupPrepend: bootstrapvue["BInputGroupPrepend"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BCard: bootstrapvue["BCard"],
    BModal: bootstrapvue["BModal"],
    BImg: bootstrapvue["BImg"],
    BButton: bootstrapvue["BButton"],
    vSelect: vue_select,
    PaymentMethodSelect: layouts_components_PaymentMethodSelect_vue,
    BForm: bootstrapvue["BForm"],
    ValidationProvider: veevalidate["ValidationProvider"],
    ValidationObserver: veevalidate["ValidationObserver"],
    KycNotComplete: layouts_components_KycNotComplete_vue,
    BContainer: bootstrapvue["BContainer"],
    AddPaymentMethod: layouts_components_AddPaymentMethod_vue,
    GoldUser: assets_rashi_coin_gold_user_svg,
    Errors: layouts_components_Errors_vue
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  computed: {
    ...vuex.mapState("user", ["refData", "user", "coins"])
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    showHidePop: {
      type: Function,
      default: () => {}
    },
    feePercent: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      completedOrders: 0,
      completionRate: 0,
      paymentWindow: "0 mins",
      releaseTime: "0 mins",
      userName: "",
      firstLetter: "",
      unitPrice: 0,
      paymentMethods: "",
      paymentMethodsOptions: [],
      fee: 0,
      currency: "",
      coin: "",
      terms: "",
      amount: "",
      quantity: "",
      displayQuantity: "",
      currencyUrl: "",
      coinUrl: "",
      required: validations["required"],
      minAmount: validations["minAmount"],
      maxAmount: validations["maxAmount"],
      minQuantity: validations["minQuantity"],
      updatingInput: false,
      showPop: false,
      showAddPaymentMethod: false,
      AddPayment: false,
      lastEdit: "",
      warningMsg: "",
      availableBalance: 0
    };
  },
  watch: {
    amount(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (!this.updatingInput) {
          let newValue1 = newValue || 0;
          this.lastEdit = "amount";
          this.updatingInput = true;
          this.displayQuantity = parseFloat((newValue1 / (this.unitPrice * (1 - this.feePercent / 100))).toFixed(this.refData.coinDecimal || utils_constants["coinDecimal"]));
          this.fee = parseFloat((this.displayQuantity * this.feePercent / 100).toFixed(this.refData.coinDecimal || utils_constants["coinDecimal"]));
          setTimeout(() => {
            this.updatingInput = false;
            this.checkValidation();
          }, 50);
        }
      }
    },
    displayQuantity(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (!this.updatingInput) {
          let newValue1 = newValue || 0;
          this.lastEdit = "quantity";
          this.updatingInput = true;
          this.fee = parseFloat((newValue1 * this.feePercent / 100).toFixed(this.refData.coinDecimal || utils_constants["coinDecimal"]));
          this.amount = parseFloat(((newValue1 - this.fee) * this.unitPrice).toFixed(this.refData.fiatDecimal || utils_constants["fiatDecimal"]));
          setTimeout(() => {
            this.updatingInput = false;
            this.checkValidation();
          }), 50;
        }
      }
    },
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setData();
      }
    }
  },
  mounted() {
    if (this.value && this.value.id) {
      this.setData();
    }
  },
  methods: {
    validateKeyPress(event) {
      const key = event.key;
      if (!/^\d$/.test(key) && key !== "." && key !== "Backspace") {
        event.preventDefault();
      } else {}
    },
    openAddPayment(flag) {
      if (!this.user || !this.user.verificationStatus || this.user.verificationStatus !== "APPROVED") {
        this.onModalHidden(true);
        this.warningMsg = this.$t("Kyc.kycNotCompleteForPayment", {
          add: "add"
        });
        return;
      }
      this.AddPayment = flag;
    },
    closePaymentPop(flag) {
      this.AddPayment = false;
      if (flag) {
        this.getOrderDetails();
      }
    },
    async checkValidUser() {
      if (!this.user || !this.user.verificationStatus || this.user.verificationStatus !== "APPROVED") {
        this.onModalHidden(true);
        this.warningMsg = this.$t("Kyc.kycNotCompleteOrder");
        return false;
      }
      return true;
    },
    async getOrderDetails(data) {
      try {
        let paymentMethods = [];
        const verificationStatus = await this.checkValidUser();
        if (!verificationStatus) {
          return;
        }
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/ad/detail/${this.value.id}`
        }, {}, {
          isLoading: true
        });
        const adDetail = (res && res.ad) ? res.ad : res;
        if (adDetail && (adDetail.sellerPaymentMethods || adDetail.paymentMethods || adDetail.id)) {
          if (adDetail.sellerPaymentMethods && adDetail.sellerPaymentMethods.length) {
            paymentMethods = adDetail.sellerPaymentMethods.filter(obj1 => this.value.paymentMethodsArray.some(obj2 => obj1.paymentMethod === obj2));
            this.paymentMethodsOptions = paymentMethods.map(item => {
              return {
                name: `${item.paymentMethod} : ${item.accountId}`,
                paymentMethod: item.paymentMethod,
                accountId: item.accountId,
                config: item.config,
                id: item.id
              };
            });
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res && res.error && res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: (error && error.message) || String(error),
            icon: "EditIcon",
            variant: "danger"
          }
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getUserEmail(email) {
      if (email && email.length) {
        this.userName = await hideEmail.apply(this, [`${email}`]);
        this.firstLetter = email[0];
      } else {
        this.userEmail = "";
        this.firstLetter = "";
      }
    },
    setData() {
      if (this.value && this.value.id) {
        this.currency = this.value.fiat;
        this.unitPrice = this.value.rate;
        this.coin = this.value.coin;
        this.terms = this.value.terms;
        this.userName = this.value.userName || "";
        this.paymentWindow = utils_constants.formatMinS(this.value.paymentTimeLimit);
        this.completionRate = this.value.completionRate;
        this.releaseTime = utils_constants.formatMinS(this.value.avgPayTime);
        this.completedOrders = this.value.totalOrder;
        // Coin icon fallback
        if (this.value.coinImgUrl) {
          this.coinUrl = this.value.coinImgUrl;
        } else if (this.coins && this.coins.length) {
          const foundCoin = this.coins.find(c => c.id === this.coin || c.coin === this.coin);
          this.coinUrl = foundCoin ? foundCoin.coinImgUrl : "";
        } else {
          const coinMap = {
            USDT: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
            USDT_TRX: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
            BTC: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
            ETH: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
            TRX: "https://assets.coingecko.com/coins/images/1094/small/tron-logo.png"
          };
          this.coinUrl = coinMap[this.coin] || "";
        }

        // Currency (fiat) icon fallback
        if (this.value.currencyImgUrl) {
          this.currencyUrl = this.value.currencyImgUrl;
        } else {
          const fiatMap = {
            USD: "https://flagcdn.com/24x18/us.png",
            EUR: "https://flagcdn.com/24x18/eu.png",
            RUB: "https://flagcdn.com/24x18/ru.png",
            INR: "https://flagcdn.com/24x18/in.png",
            UAH: "https://flagcdn.com/24x18/ua.png",
            KZT: "https://flagcdn.com/24x18/kz.png"
          };
          this.currencyUrl = fiatMap[this.currency] || "";
        }
        this.getBalance();
        if (this.value.paymentMethods && this.value.paymentMethods.length) {
          this.paymentMethodsOptions = this.value.paymentMethods.map(item => {
            if (typeof item === "string") {
              return {
                name: item,
                paymentMethod: item,
                accountId: item,
                config: {},
                id: item
              };
            }
            return {
              name: item.accountId && item.accountId !== item.paymentMethod
                ? `${item.paymentMethod} : ${item.accountId}`
                : (item.name || item.paymentMethod),
              paymentMethod: item.paymentMethod,
              accountId: item.accountId,
              config: item.config || {},
              id: item.id
            };
          });
          if (this.paymentMethodsOptions.length && !this.paymentMethods) {
            this.paymentMethods = this.paymentMethodsOptions[0].id;
          }
        } else {
          this.paymentMethodsOptions = [];
          this.showAddPaymentMethod = true;
        }
        if (this.userName && this.userName.length) {
          this.firstLetter = this.value.userName[0];
        } else {
          this.getUserEmail(this.value.email);
        }
      } else {
        this.completedOrders = 0;
        this.completionRate = 0;
        this.paymentWindow = "";
        this.releaseTime = "";
        this.userName = "";
        this.unitPrice = 0;
        this.assigneeOptions = [];
        this.currency = "";
        this.coin = "";
        this.firstLetter = "";
        this.terms = "";
        this.completedOrders = "";
        this.currencyUrl = "";
        this.showHidePop(false);
      }
    },
    checkValidation() {
      this.$refs.createSell.validate().then(success => {});
    },
    validationForm() {
      this.$refs.createSell.validate().then(success => {
        if (success) {
          this.createSell();
        }
      });
    },
    onModalHidden(props) {
      this.showPop = props;
      if (!props) {
        this.warningMsg = "";
      }
    },
    async createSell() {
      try {
        if (!this.user || !this.user.verificationStatus || this.user.verificationStatus !== "APPROVED") {
          this.onModalHidden(true);
          this.warningMsg = this.$t("Kyc.kycNotCompleteOrder");
          return;
        }
        const res = await new libs_api_api().api({
          method: "post",
          url: "p2p/order/create"
        }, {
          adId: this.value.id,
          orderType: "SELL",
          quantity: this.displayQuantity,
          //  quantity: this.lastEdit === "quantity" ? this.displayQuantity : undefined,
          // amount: this.lastEdit === "amount" ? this.amount : undefined,
          sellerPaymentMethodId: this.paymentMethods
        }, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus === "SUCCESS") {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("ads.OrderCreatedSuccessfully"),
              icon: "EditIcon",
              variant: "success"
            }
          });
          this.$router.push({
            name: "OrderCreated",
            params: {
              lang: this.lang || undefined,
              id: res.id
            }
          });
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async getBalance() {
      try {
        if (this.coin) {
          const res = await new libs_api_api().api({
            method: "GET",
            url: `asset/balance`
          }, {
            asset: this.coin
          }, {
            isLoading: true
          });
          if (res && res.availableBalance) {
            this.availableBalance = res.availableBalance;
            // this.availableBalance = res.totalBalance;
          } else if (res && res.error && res.error.message) {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        } else {
          this.availableBalance = 0;
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/buy-sell/PopupSell.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
[dir=ltr] .green {
  border-radius: 6px 0px 0px 6px;
}[dir=rtl] .green {
  border-radius: 0px 6px 6px 0px;
}
[dir] .advertisers-text {
  margin-top: 5px;
}
[dir] .white {
  background: #fff;
}
[dir=ltr] .white {
  border-radius: 0px 6px 6px 0px;
}
[dir=rtl] .white {
  border-radius: 6px 0px 0px 6px;
}
.spotpumkin {
  color: #100f0f;
  font-size: 19.844px;
  font-weight: 500;
  line-height: 24px;
}
.KYC {
  color: #f8fbfa;
  font-size: 11.813px;
  font-weight: 400;
  line-height: 16px;
}
[dir] .KYC {
  margin-top: 10px;
}
.order-text {
  color: var(--text-black-color);
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
}
[dir] .modal-green {
  background-color: white;
  border-radius: 6px;
}
.horizontal {
  color: var(--text-black-color);
  font-size: 13.891px;
  font-weight: 600;
  line-height: 16px;
}
.trading-text {
  color: var(--text-black-color);
  font-size: 13.453px;
  font-weight: 400;
  line-height: 20.12px;
}
@media (max-width: 991px) {
[dir] .green {
    border-radius: 6px 6px 0px 0px;
}
[dir] .white {
    background: #fff;
    border-radius: 0px 0px 6px 6px;
}
}
[dir=ltr] .user-level {
  margin-left: 5px;
}
[dir=rtl] .user-level {
  margin-right: 5px;
}
[dir=ltr] .border-right {
  border-right: 1px solid #81858c;
}
[dir=rtl] .border-right {
  border-left: 1px solid #81858c;
}
[dir] .mt-1-5 {
  margin-top: 12px;
}
[dir] .margin-top-10 {
  margin-top: 10px;
}
[dir] .mb-0-5 {
  margin-bottom: 5px;
}
.center-form {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
[dir] .modal-green .pt-0-custom {
  padding-top: 0px !important;
  margin-top: -10px;
}
.terms-scroll {
  max-height: 200px;
  overflow-y: auto;
}
.custom-add-pay {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.custom-add-pay .select-payment-drop-down {
  width: calc(100% - 50px);
}
.custom-add-pay .btn.btn-icon.rounded-circle.btn-primary {
  max-height: 40px;
  max-width: 40px;
  min-height: 40px;
  min-width: 40px;
}
.you-buy-w {
  min-width: 106px;
}
[dir=ltr] .you-buy-w {
  border-right: none;
}
[dir=rtl] .you-buy-w {
  border-left: none;
}
.you-buy-input {
  min-width: 120px;
  display: flex;
  justify-content: end;
}
[dir=ltr] .you-buy-in {
  border-left: none;
}
[dir=rtl] .you-buy-in {
  border-right: none;
}
[dir=ltr] .icon-w {
  margin-right: 0.35;
}
[dir=rtl] .icon-w {
  margin-left: 0.35;
}
[dir] .orderlt {
  margin-bottom: 10px;
}
.text-lable {
  color: #7f7f7f;
  font-size: 14px;
  font-weight: 500;
  line-height: 10px;
}
</style>
